import React, { useState } from 'react';
import '../styles/Contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    organization: '',
    subject: '',
    message: '',
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /**
   * USE THIS SECTION TO IMPLEMENT TO CONNECT TO THE BACKEND SERVER
   */

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     // Send data to your backend API
  //     const response = await fetch('https://your-api-endpoint.com/contact', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(formData),
  //     });

  //     if (response.ok) {
  //       // Show success message
  //       setFormSubmitted(true);
  //       // Reset form
  //       setFormData({
  //         name: '',
  //         email: '',
  //         phone: '',
  //         organization: '',
  //         subject: '',
  //         message: ''
  //       });
  //     } else {
  //       // Handle error response
  //       console.error('Form submission failed');
  //       // You might want to show an error message to the user
  //     }
  //   } catch (error) {
  //     console.error('Error submitting form:', error);
  //     // Handle network errors
  //   }
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // In a real application, you would send this data to your backend
    setFormSubmitted(true);
    // Reset form after submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      organization: '',
      subject: '',
      message: '',
    });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <h1>
            Entre em <span className="text-highlight">Contato</span>
          </h1>
          <p>
            Estamos prontos para atender às suas necessidades em dosimetria e
            proteção radiológica
          </p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-cards">
            <div className="contact-card">
              <div className="contact-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <h3>Endereço</h3>
              <p>
                Quadra 501 Sul. Av. NS-A, Conjunto 02 Lote 10, s/n - Plano
                Diretor Sul.
              </p>
              <p>Palmas - TO, 77016-008</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <h3>Telefone</h3>
              <p>(62) 98227-0793</p>
              <p>Segunda a Sexta: 8h às 18h</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <h3>E-mail</h3>
              <p>rubens@safedose.com.br</p>
              {/* <p>adm@safedose.com.br</p> */}
            </div>
          </div>
        </div>
      </section>

      <section className="form-section">
        <div className="container">
          <div className="contact-form-container">
            <div className="form-header">
              <h2>Envie sua Mensagem</h2>
              <p>Responderemos o mais breve possível</p>
            </div>

            {formSubmitted ? (
              <div className="form-success">
                <div className="success-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <h3>Mensagem enviada com sucesso!</h3>
                <p>Agradecemos seu contato. Nossa equipe retornará em breve.</p>
                <button
                  className="btn btn-primary"
                  onClick={() => setFormSubmitted(false)}
                >
                  Enviar Nova Mensagem
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Nome Completo*</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Seu nome"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">E-mail*</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="seu.email@exemplo.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Telefone</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="(00) 00000-0000"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="organization">Instituição</label>
                    <input
                      type="text"
                      id="organization"
                      name="organization"
                      value={formData.organization}
                      onChange={handleChange}
                      placeholder="Nome da sua instituição"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Assunto*</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Assunto da mensagem"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Mensagem*</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Escreva sua mensagem aqui..."
                  ></textarea>
                </div>

                <div className="form-submit">
                  <button type="submit" className="btn btn-primary">
                    Enviar Mensagem
                  </button>
                </div>
              </form>
            )}
          </div>

          <div className="map-container">
            <div className="map-overlay">
              <h3>Nossa Localização</h3>
              <p>Visite-nos em nosso escritório</p>
            </div>
            <div className="google-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3926.5743777454113!2d-48.337684823951726!3d-10.21517688990143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x933b34b968167255%3A0x485125690a3f4bd!2sPalmas%20Cancer%20Center!5e0!3m2!1sen!2sus!4v1743463438219!5m2!1sen!2sus"
                width="550"
                height="800"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Nossa Localização"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Prefere falar por WhatsApp?</h2>
            <p>
              Clique no botão flutuante no canto inferior direito da tela para
              iniciar uma conversa pelo WhatsApp.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
